import {decrypt, encryptEntry} from '@/services/SecurityService';
import CryptoJS from 'crypto-js/core';
import {v4 as uuidv4} from 'uuid';
import axios, {AxiosResponse, ResponseType} from 'axios';


let DB: IDBDatabase;
const DB_NAME = 'CalcApp';
let appVersion = 0;
let readFromAWS = true;

const ctx: Worker = self as any;
let fetchUrl = '';

const USERNAME = "generalUser123";
const PASSWORD = "U8CGKbJJa9e64mGt";

/**
 * Load manifest file default journey sets in the background.
 * Avoid importing files into this method.
 * As such Data Storage is duplicated with simplifications.
 * Also need to know the index db's appVersion
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers
 */
ctx.addEventListener('message',  async (event: MessageEvent) => {
        const payload = JSON.parse(event.data);
        appVersion = payload.appVersion;
        fetchUrl = payload.fetchUrl;
        readFromAWS = payload.readFromAWS;
        await doWork(payload.defaultSets);
    }
);

async function doWork(ids: string[]) {
    for (const id of ids) {
        try {
            await readDefault(id);
            
            ctx.postMessage(id);
        } catch(e) {
            console.error('Error loading default');
        }
    }
}
async function readDefault(id: string) {
    const fileName = `journeySet_${id}.json`;
    const fileData = readFromAWS ? (await getFromS3(fileName))?.data : await readFile(`../assets/data/${fileName}`);
    if(!fileData || (!readFromAWS && !fileData.content)) {
        console.error('Error loading default content');
        return;
    }
    const journeySet = readFromAWS ? fileData : parseContent(fileData.content);
    await saveJourneySetAndData(journeySet);
}

async function readFile(filePath: string) {
    const file = await fetch(filePath);
    return await file.json();
}

function parseContent(chunks: string[]) {
    let quadrantString = '';
    chunks.forEach((chunk: string) => {
        quadrantString += JSON.parse(decrypt(chunk).toString(CryptoJS.enc.Utf8));
    });

    return JSON.parse(quadrantString);
}

function getDatabase(): Promise<IDBDatabase>  {
    const request = indexedDB.open(DB_NAME, appVersion);

    return new Promise((resolve, reject) => {
        request.onerror = () => {
            reject('Error');
        };

        request.onsuccess = async (e) => {
            DB = (e as DataEvent).target.result;
            resolve(DB);
        }; });
}

async function saveObject(storeName: string, object: any, keyNameForArray = '') {
    const db = await getDatabase();

    return new Promise<void>((resolve,reject) => {
        try {
            const trans = db.transaction([storeName], 'readwrite');
            trans.oncomplete = () => {
                resolve();
            };

            const store = trans.objectStore(storeName);
            const encryptedObject = encryptEntry(object, keyNameForArray ? object[keyNameForArray] : [], keyNameForArray);
            if (store.autoIncrement) {
                store.put(encryptedObject);
            } else {
                store.put(encryptedObject, 1);
            }
        } catch(e) {
            reject(e);
        }
    });
}


export async function deleteObject(storeName: string, key: string | number) {
    const db = await getDatabase();
    return new Promise<void>((resolve) => {
        const trans = db.transaction([storeName], "readwrite");
        trans.oncomplete = () => {
            resolve();
        };

        const store = trans.objectStore(storeName);
        store.delete(key);
    });
}


async function saveJourneySetAndData(journeySet: any) {
    journeySet.alreadyDownloaded = true;
    journeySet.updateAvailable = false;
    journeySet.numberOfJourneys = journeySet.journeys?.length || 0;
    if (journeySet.icon) {
        journeySet.iconId = uuidv4();
        await saveMedia({ id: journeySet.iconId, content: journeySet.icon || '' });
    }
    
    for (const journey of journeySet.journeys || []) {
        if (journey.audioFile) {
            journey.audioFileId = uuidv4();
            await saveMedia({id: journey.audioFileId , content: journey.audioFile || '' });
        }
        //Force it into this format so it loads faster on the Journeys page
        await saveJourney({
            id: journey.id,
            name: journey.name,
            description: journey.description,
            audioFileId: journey.audioFileId,
            journeySetId: journeySet.id,
            isComplete: false,
            tabs: journey.tabs,
            order: journey.order
        });
    }
    
    //index db transactions are odd, update the journeyset as downloaded last transaction so failure of everything will 
    //trigger a reload.
    await updateJourneySet(journeySet);

}

async function updateJourneySet(journeySet: any) {
    const lowercaseId = journeySet.id.toLowerCase();
    const uppercaseId = journeySet.id.toUpperCase();
    await deleteObject('journeySet', lowercaseId);
    await deleteObject('journeySet', uppercaseId);
    await saveObject('journeySet', journeySet);
}


async function saveJourney(journey: any) {
    await saveObject('journey', journey, 'tabs');
}


async function saveMedia(media: any) {
    await saveObject('media', media);
}


interface DataEvent extends Event {
    target: any;
}

async function getFromS3(key: string, responseType: ResponseType = 'json'): Promise<AxiosResponse> {
    const getUrl = `${fetchUrl}${key}`;
    return await axios.get(getUrl, {
        responseType : responseType,
        auth: {
            username: USERNAME,
            password: PASSWORD,
        }
    }).catch(function () {
        return {data: responseType === 'json' ? {} : ''} as AxiosResponse;
    });
}
